/* eslint-disable no-unused-vars */

import {logCreativeResult} from "../utils/log";
import {creativeName} from "../utils/creative";
import {contextTypeKeys, extraKeys} from "../photolab/etc";
import Creative from "../photolab/Creative";
import {webviewAnalyticsEvent} from "../utils/webview";
import clientStorage from "../utils/client-storage";

export default {

  creativeStarted: (processing, creative) => {
    webviewAnalyticsEvent("generation_start", [
      clientStorage.getSelectedPhotosAmount(),
      creative.getExtra(Creative.EXTRA_POSITION) + 1,
      creative.templateId,
      creative.getExtra(extraKeys.body),
      creative.getExtra(extraKeys.gender),
      creative.getExtra(extraKeys.stylization),
    ], {
      wt_hotify: {
        orig_bg: creative.getExtra(extraKeys.contextType) === contextTypeKeys.original ? "yes" : "no",
        block_cnt: clientStorage.getSelectedBlocksAmount(),
      },
    });
  },

  creativeProcessed: (processing, creative) => {
    webviewAnalyticsEvent("generation_finish", [
      clientStorage.getSelectedPhotosAmount(),
      creative.getExtra(Creative.EXTRA_POSITION) + 1,
      creative.templateId,
      creative.getExtra(extraKeys.body),
      creative.getExtra(extraKeys.gender),
      creative.getExtra(extraKeys.stylization),
    ], {
      wt_hotify: {
        orig_bg: creative.getExtra(extraKeys.contextType) === contextTypeKeys.original ? "yes" : "no",
        block_cnt: clientStorage.getSelectedBlocksAmount(),
      },
    });

    logCreativeResult(
      creativeName(creative),
      processing.files.map((f) => ({url: f.url})),
      [{url: creative.result}],
      false,
      {
        gender: creative.getExtra(extraKeys.gender),
        body: creative.getExtra(extraKeys.body),
        stylization: creative.getExtra(extraKeys.stylization),
        context_type: creative.getExtra(extraKeys.contextType),
        is_safe_prompt: creative.getExtra("is_safe_prompt"),
        answers: processing.getExtra("answers"),
        age_verdict: processing.getExtra("age_verdict"),
        bodies_states: processing.getExtra("bodies_states"),
        combo: creative.getExtra(Creative.EXTRA_COMBO_STEPS),
        result_moderation_result: creative.getExtra("result_moderation_result", {}),
        source_moderation_result: creative.getExtra("source_moderation_result", {}),
        moderation_tries: (creative.getExtra("tries_by_moderation", 0) + 1),
      }
    );
  },

  creativeFailed: (processing, creative) => {
    webviewAnalyticsEvent("generation_failed", [
      clientStorage.getSelectedPhotosAmount(),
      creative.getExtra(Creative.EXTRA_POSITION) + 1,
      creative.templateId,
      creative.getExtra(extraKeys.body),
      creative.getExtra(extraKeys.gender),
      creative.getExtra(extraKeys.stylization),
    ], {
      wt_hotify: {
        orig_bg: creative.getExtra(extraKeys.contextType) === contextTypeKeys.original ? "yes" : "no",
        block_cnt: clientStorage.getSelectedBlocksAmount(),
        error: creative.error?.message,
      },
    });

    logCreativeResult(
      creativeName(creative),
      processing.files.map((f) => ({url: f.url})),
      [{error: creative.error}],
      false,
      {
        gender: creative.getExtra(extraKeys.gender),
        body: creative.getExtra(extraKeys.body),
        stylization: creative.getExtra(extraKeys.stylization),
        context_type: creative.getExtra(extraKeys.contextType),
        is_safe_prompt: creative.getExtra("is_safe_prompt"),
        answers: processing.getExtra("answers"),
        age_verdict: processing.getExtra("age_verdict"),
        bodies_states: processing.getExtra("bodies_states"),
        combo: creative.getExtra(Creative.EXTRA_COMBO_STEPS),
        result_moderation_result: creative.getExtra("result_moderation_result", {}),
        source_moderation_result: creative.getExtra("source_moderation_result", {}),
        moderation_tries: (creative.getExtra("tries_by_moderation", 0) + 1),
      }
    );
  },

};